import { createContext, useState, useMemo,useRef} from "react";

// Create context
export const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {  
    const [selectedIndicator, setSelectedIndicator] = useState(null);
    const [breadcrumbData, setBreadcrumbData] = useState([]);
    const currentPolygonRef = useRef(null);

    const contextValue = useMemo(() => ({   
        selectedIndicator,
        breadcrumbData,
        currentPolygonRef
    }), [selectedIndicator,breadcrumbData,currentPolygonRef]);

    const contextActions = {
        setSelectedIndicator,
        setBreadcrumbData
    };

    return (
        <SidebarContext.Provider value={{ ...contextValue, ...contextActions }}>
            {children}
        </SidebarContext.Provider>
    );
};